export default {
    name: 'Settings'
}
